export async function newsletterTranslator(context, payload) {
  const subject = payload.subject?.['es'] ?? null
  const contenido = payload.contenido ?? null
  const languages = ['es', 'en', 'fr', 'de', 'it']
  if (subject) {
    payload.subject = await context.client.translate(subject, 'subject')
  }
  if (contenido) {
    for (let i = 0; i < contenido.length; i++) {
      console.log(contenido[i])
      const val = contenido[i]
      if (
        val['id_tipo'] === 'h1' ||
        val['id_tipo'] === 'p' ||
        val['id_tipo'] === 'h2' ||
        val['id_tipo'] === 'w'
      ) {
        const translated = await context.client.translate(
          val['es'],
          val['id_tipo']
        )

        if (translated) {
          languages.forEach((language) => {
            val[language] = translated[language]
          })
        }
      }
    }
  }

  return payload
}
